import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { mapObjIndexed, values } from 'ramda';

import cx from 'classnames';
import s from './Profile.css';


const AdditionalInfo = ({ fields, options, labels, updateValue }) => {
  return (
    <section className={s.component}>
      <h3 className={s.header}>
        Additional Information
      </h3>
      {values(mapObjIndexed((field, key) =>
        <div aria-labelledby={`additionalInfo__${key}Input`} role="listbox" className={s.group} key={key}>
          <label
            id={`additionalInfo__${key}`}
            className={s.label}
            htmlFor={`additionalInfo__${key}Input`}
          >
            {labels[key]}
          </label>
          <div id={`additionalInfo__${key}Input`} className={s.controlContainer}>
            <Select
              className={cx(s.flex, "composeMessage")}
              optionClassName="composeMessage__option"
              searchable={false}
              clearable={false}
              value={field}
              options={options[key]}
              onChange={val => updateValue(key, val.value)}
              inputProps={{title:labels[key], 'aria-label': `Select a ${labels[key]}`}}
            />
          </div>
        </div>, fields)
      )}
    </section>
  );
};


AdditionalInfo.propTypes = {
  fields: PropTypes.object,
  options: PropTypes.object,
  labels: PropTypes.object,
  updateValue: PropTypes.func,
};

export default AdditionalInfo;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/AdditionalInfo.js